import React from "react";
import { motion } from "framer-motion";
import { FaBell, FaChartLine, FaUsers, FaTasks } from "react-icons/fa";
import { crmCommandMetrics } from "../../data/crmPageContent";
import { CrmCommandCenterMockup, CrmFloatingCard } from "./CrmMockups";
import { CrmReveal, CrmStagger, CrmStaggerItem } from "./CrmMotion";

const highlights = [
    { icon: FaChartLine, label: "Active Leads", desc: "Real-time lead pipeline" },
    { icon: FaTasks, label: "Pipeline Value", desc: "Revenue at every stage" },
    { icon: FaUsers, label: "Team Performance", desc: "Quota & activity tracking" },
    { icon: FaBell, label: "Follow-Up Reminders", desc: "Never miss an action" },
];

export const CrmCommandCenterSection = () => (
    <section className="crm-command" id="crm-command">
        <div className="crm-container">
            <CrmReveal className="crm-command__header">
                <h2 className="crm-h2">Your CRM Command Center</h2>
                <div className="crm-section-accent crm-section-accent--center" />
                <p className="crm-lead">
                    Everything your team needs — active leads, pipeline value, revenue tracking,
                    team performance, and follow-up reminders — in one premium dashboard.
                </p>
            </CrmReveal>

            <div className="crm-command__body">
                <div className="crm-command__showcase">
                    <motion.div
                        className="crm-command__dashboard"
                        initial={{ opacity: 0, y: 40, scale: 0.97 }}
                        whileInView={{ opacity: 1, y: 0, scale: 1 }}
                        viewport={{ once: false, amount: 0.2 }}
                        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                    >
                        <CrmCommandCenterMockup />
                    </motion.div>
                    {crmCommandMetrics.map((m, i) => (
                        <CrmFloatingCard
                            key={m.label}
                            label={m.label}
                            value={m.value}
                            trend={m.trend}
                            className={`crm-command-float--${i}`}
                            delay={0.2 + i * 0.12}
                        />
                    ))}
                </div>

                <CrmStagger className="crm-command__highlights">
                    {highlights.map((h) => {
                        const Icon = h.icon;
                        return (
                            <CrmStaggerItem key={h.label}>
                                <motion.div className="crm-command__highlight" whileHover={{ y: -4, boxShadow: "0 12px 32px rgba(158, 0, 255,0.12)" }}>
                                    <div className="crm-command__highlight-icon">
                                        <Icon size={18} />
                                    </div>
                                    <div>
                                        <strong>{h.label}</strong>
                                        <span>{h.desc}</span>
                                    </div>
                                </motion.div>
                            </CrmStaggerItem>
                        );
                    })}
                </CrmStagger>
            </div>
        </div>
    </section>
);
